






















































































































































































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import FiltrosBusqueda from '@/pantallas/Conecta/Clientes/FiltrosBusqueda.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import { save_report } from '@/pantallas/Informes/partes/fetchSaveReport';
import { postReporteTime } from '@/pantallas/Informes/partes/postReporteTime';
import MensajeValidacionHRef from '@/pantallas/Informes/partes/MensajeValidacionHRef.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import MensajeValidacion from '../../../reusable/Mantenedor/MensajeValidacion.vue';
const { AgGridVue } = require('ag-grid-vue');
import { actionsEvent } from '@/setup';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  ProcessCellForExportParams,
  CsvExportParams,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
import {
  checkboxColumnDef,
  makeAccionesColumnDef_DEPRECATED,
  creadoPorColumnDefs,
  modificadoPorColumnDefs,
  fechaCreacionColumnDefs,
  fechaModificacionColumnDefs,
} from '@/reusable/Grid/aggridColumnDefUtils';
import { LoadingService } from '@/services/loadingService';
import HandleErrors from '@/config/handleErrors'; //
import { ComponenteBase, Accion } from '@/views/base/ComponenteBase';
import { title } from 'process';
import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import moment from 'moment';
import VerDetalleModal from '@/pantallas/Peajes/Tarifas/VerDetalleModal.vue';
import { fetchTelemetria } from '@/pantallas/Telemetria/fetchTelemetria';
import { Bar, Line, Doughnut, Radar } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';
@Component({
  components: {
    MantenedorGridSinCodigo,
    FiltrosBusqueda,
    VerDetalleModal,
    DatePicker,
    TimePicker,
    MensajeValidacion: MensajeValidacionHRef,
    FormFieldsContainer,
    doughnutComp: Doughnut,
    lineComp: Line,
    AgGridVue,
  },
})
export default class Datos extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.TelemetriaDashboard;
  accionesTotales: PermisoAccion[] = [];
  requestsStart: number = 0;
  row: string = 'pdf';
  isFormValid: boolean = false;
  fechaDesde: any = moment(new Date()).add(-1, 'weeks');
  fechaHasta: any = moment();
  horaDesde: any = moment('00:00', 'HHmm');
  horaHasta: any = moment('23:59', 'HHmm');
  checkAllReport: boolean = false;
  vehiculos: any = [];
  vehiculoSeleccionados: any = [];
  reportList: any[] = [];
  reportType: any = [];
  showBtnCancelar: boolean = false;
  showValidacionReporteRestricciones: boolean = false;
  tituloValidacion: string = '';
  mensajeValidacion: string = '';
  mensajeValidacionBot: string = '';
  mensajeHRef: any = null;
  showValidacionReporteTime: boolean = false;
  dataInforme: any = [];
  data: any = [];
  busqueda: boolean = false;
  allCreated: boolean = false;

  async generarReporte() {
    var valid = await this.$validator.validateAll();
    if (!valid) {
      return;
    }
    var v: any = [];
    this.vehiculos.forEach((x: any) => {
      if (x['cod_vehiculo'] == this.vehiculoSeleccionados) {
        v.push({ unidad: x['patente'] });
      }
    });
    this.dataInforme = {
      vehiculos: [this.vehiculoSeleccionados.toString()],
      fini:
        this.fechaDesde.format('YYYY-MM-DD').toString() +
        ' ' +
        this.horaDesde.format('HH:mm:ss').toString(),
      ffin:
        this.fechaHasta.format('YYYY-MM-DD').toString() +
        ' ' +
        this.horaHasta.format('HH:mm:ss').toString(),
      // vehiculos_seleccionados: {
      //   vehiculos: v,
      //   flotas: [],
      //   etiquetas: [],
      // },
      user: localStorage.getItem('user')
        ? JSON.parse(localStorage.getItem('user')).id
        : '',
      client: localStorage.clienteDefecto,
      graficos: this.reportType,
    };
    this.aceptaGeneraInforme(true);
  }

  aceptaGeneraInforme(val: any) {
    this.showBtnCancelar = false;
    this.showValidacionReporteRestricciones = false;
    if (val) {
      this.loadingService.showLoading();
      fetchTelemetria(this.dataInforme, 'getGraficosInstantaneos')
        .then((response: any) => {
          if (response.data.CODIGO_RESPUESTA == '1') {
            if (response.data.MENSAJE_RESPUESTA != 'OK') {
              // self.gridApi.setRowData([{}]);
              this.$snotify.success('Sin Data');
              this.busqueda = false;
            } else {
              this.data = response.data.data;
              // this.busqueda = true;
            }
          } else {
            this.busqueda = false;
            this.$snotify.error('Sin Registros');
          }
        })
        .finally(() => {
          this.loadingService.hideLoading();
        });
    }
  }

  textoComprimido(item: any) {
    let retorno: string = '';
    if (item.length > 14) {
      retorno = item.substr(0, 30) + '...';
    } else {
      retorno = item;
    }
    return retorno;
  }

  showLoading() {
    this.requestsStart += 1;
    if (this.requestsStart == 1) {
      this.loadingService.showLoading();
    }
  }
  hideLoading() {
    this.requestsStart -= 1;
    if (this.requestsStart == 0) {
      this.loadingService.hideLoading();
    }
  }

  selectAllReport() {
    if (this.checkAllReport === true) {
      this.reportList.forEach((x: any) => {
        this.reportType.push(x);
      });
    } else {
      this.reportType = [];
    }
  }

  @Watch('data')
  ondataChanged(value: string, oldValue: string) {
    //(this.$refs.grafico as Line).addPlugin(ChartDataLabels);
    this.busqueda = true;
    // this.graficosCreados()
    this.$nextTick(() => {
      setTimeout(this.cargarGrafico, 2000);
    });
  }

  async graficosCreados() {
    var index = 0;
    while (this.data.length > index) {
      if (this.$refs['grafico' + index]) {
        console.log(
          'referencia creada ' + index,
          this.$refs['grafico' + index]
        );

        var refGrafico = this.$refs['grafico' + index];
        (refGrafico as Line).addPlugin(ChartDataLabels);
        (refGrafico as Line).renderChart(
          {
            labels: this.data[index].labels,
            datasets: [
              {
                label: this.data[index].text,
                data: this.data[index].values,
                backgroundColor: '#d49231',
              },
            ],
          },
          {
            responsive: true,
            maintainAspectRatio: false,
          }
        );
        index += 1;
        // this.$nextTick(() => {setTimeout(this.cargarGrafico, 500)})
      } else {
        console.log('repite');
        await this.sleep(500);
      }
    }
  }

  sleep(ms: number): Promise<void> {
    return new Promise(resolve => {
      setTimeout(resolve, ms);
    });
  }

  cargarGrafico() {
    for (let index = 0; index < this.data.length; index++) {
      var refGrafico = this.$refs['grafico' + index];
      console.log(refGrafico);
      (refGrafico as Line).renderChart(
        {
          labels: this.data[index].labels,
          datasets: [
            {
              label: this.data[index].ref,
              data: this.data[index].values,
              backgroundColor: this.dynamicColors(),
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: true,
            text: this.data[index].title,
          },
        }
      );
    }
  }

  dynamicColors() {
    var r = Math.floor(Math.random() * 255);
    var g = Math.floor(Math.random() * 255);
    var b = Math.floor(Math.random() * 255);
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  }

  mounted() {
    this.getVehiculos();
    this.getReportList();
  }

  getReportList() {
    this.loadingService.showLoading;
    fetchTelemetria({}, 'filtrosGraficosCustom')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          if (response.data.data.length === 0) {
            // self.gridApi.setRowData([{}]);
            this.$snotify.success('Sin tipo de reportes');
            // params.successCallback([{}], 0);
            // self.gridApi.showNoRowsOverlay();
          } else {
            this.reportList = response.data.data[0];
            // console.log(this.reportList)
            this.reportList = Object.entries(this.reportList).map(
              ([value, text]) => ({ text, value })
            );
            this.reportList = this.reportList.sort((a, b) =>
              a.text.localeCompare(b.text)
            );
            // console.log(this.reportList)

            // console.log(response.data.data[0])
            // params.successCallback(
            //   response.data.data,
            //   response.data.data.length
            // );
            // self.gridApi.hideOverlay();
          }
        } else {
          this.$snotify.error('Sin Registros');
        }
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  getClientID(): number {
    return parseInt(localStorage.getItem('clienteDefecto'));
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return id;
  }

  getRut(): any {
    let rut = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user').replace(/'/g, '"'))
          .rutClienteDefecto
      : '';
    return rut;
  }

  async getVehiculos() {
    const body: {} = {
      id_cliente: this.getClientID(),
      id_usuario: this.getUserID().toString(),
      clienteDefecto: this.getClientID(),
      rut: this.getRut(),
    };
    this.loadingService.showLoading;
    fetchTelemetria(body, 'getVehiculos')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          if (response.data.data.length === 0) {
            // self.gridApi.setRowData([{}]);
            this.$snotify.success('Sin Datos');
            // params.successCallback([{}], 0);
            // self.gridApi.showNoRowsOverlay();
          } else {
            this.vehiculos = response.data.data;
            // params.successCallback(
            //   response.data.data,
            //   response.data.data.length
            // );
            // self.gridApi.hideOverlay();
          }
        } else {
          this.$snotify.error('Error al traer los registros');
        }
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  get fechaMaxima() {
    const fechaMax = moment().format('YYYY-MM-DD h:mm:ss a');
    return fechaMax;
  }
}
